"use client";

import { usePathname } from "next-intl/client";
import { Button } from "../../ui/button";
import type { ModelsCategory } from "../../../types/strapi/models";
import type { Theme } from "../../../types/strapi/common";

interface CaseListCategoryLinkProps {
  theme: Theme;
  category: ModelsCategory;
  sectionName: string;
}

function CaseListCategoryLink({
  theme,
  category,
  sectionName,
}: CaseListCategoryLinkProps) {
  const currentPath = usePathname();
  const { name, path } = category;

  const active = currentPath === path;
  const colorByTheme = theme === "dark" ? "gray" : "grayDark";

  return (
    <Button
      appearance="solid"
      color={active ? "blueDark" : colorByTheme}
      href={path}
      sectionName={`${sectionName}_${name}`}
      size="xxs"
      title={name}
    >
      {name}
    </Button>
  );
}

export default CaseListCategoryLink;
